import Axios from 'axios'
const reportRegisteredExamsService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.PENDING_SAMPLES_REPORT
    return AxiosInstance
  },
  getRegisteredExamsReport(data) {
    return this.axios().get(
      'report/register?' + 'startDate=' + data.releaseDateStart + '&endDate=' + data.releaseDateEnd + '&status=' + data.status + '&type=' + data.exportWay,
      { responseType: 'arraybuffer' }
    )
  }
}
export default reportRegisteredExamsService
